<template>
  <div v-if="currentCustomer" class="customer-page" :key="currentCustomer.id">
    <div class="ui-container right aligned">
      <div class="customer-view-header">
        <button class="ui basic button red" @click="closeCustomer">
          {{ $t('Close this customer') }}
        </button>
        <button class="ui basic button green" @click="handleRefreshCustomer">
          {{ $t('Refresh') }}
        </button>
        <select
          v-model="locale"
          class="ui fluid dropdown selection"
          style="height: 45px; width: 120px"
        >
          <option value="en">English</option>
          <option value="fr">French</option>
        </select>
      </div>
      <div class="ui right floated header">
        {{ currentCustomer.firstname }} {{ currentCustomer.lastname }}
        <h5>{{ currentCustomer.email }}</h5>
      </div>
    </div>

    <div class="ui top attached tabular menu">
      <a
        :class="{ active: currentTab == 0 }"
        class="item teal"
        @click="handleClickTab(0)"
        >{{ $t('Cart') }}
      </a>
      <a
        :class="{ active: currentTab == 1 }"
        class="item violet"
        @click="handleClickTab(1)"
        >{{ $t('Measures') }}
      </a>
      <a
        :class="{ active: currentTab == 2 }"
        class="item grey"
        @click="handleClickTab(2)"
        >{{ $t('Orders') }}
      </a>
      <a
        :class="{ active: currentTab == 3 }"
        class="item blue"
        @click="handleClickTab(3)"
        >{{ $t('Customer') }}
      </a>
    </div>

    <div
      :class="{ active: currentTab == 0 }"
      class="ui segment attached tab teal"
    >
      <cart-tab
        @switchToOrdersTab="currentTab = 2"
      ></cart-tab>
    </div>

    <div
      :class="{ active: currentTab == 1 }"
      class="ui bottom attached tab segment violet"
      :key="'measures-'+tabsKey[1]"
    >
      <measurement-tab ref="measurementTab" :customer="currentCustomer" />
    </div>

    <div
      :class="{ active: currentTab == 2 }"
      class="ui bottom attached tab segment grey"
      :key="'orders-'+tabsKey[2]"
    >
      <order-tab ref="orderTab" :customer="currentCustomer" />
    </div>

    <div
      :class="{ active: currentTab == 3 }"
      class="ui bottom attached tab segment blue"
      :key="'customer-'+tabsKey[3]"
    >
      <address-tab ref="addressTab" :customer="currentCustomer" />
    </div>
  </div>
</template>

<style scoped>
.customer-page .label {
  background: #eee;
}

.customer-page > div {
  margin-bottom: 30px;
}

.customer-view-header {
  display: flex;
  justify-content: flex-start;
}
</style>

<script>
import { mapGetters } from 'vuex'

import MeasurementTab from './tabs/MeasurementTab'
import AddressTab from './tabs/AddressTab'
import OrderTab from './tabs/OrderTab'
import CartTab from './tabs/CartTab'

export default {
  name: 'CustomerView',
  components: {
    MeasurementTab,
    AddressTab,
    OrderTab,
    CartTab
  },
  data() {
    return {
      locale: localStorage.getItem('locale') || 'fr',
      currentTab: 0,
      tabsKey: { 1: 0, 2: 0, 3: 0 }
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer',
      countries: 'getCountries'
    })
  },
  mounted() {
    if (this.currentCustomer === null) this.$router.push({ name: 'Home' })
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val
      localStorage.setItem('locale', val)
    },
  },
  methods: {
    closeCustomer() {
      this.$store.dispatch('closeCustomer')
      this.$router.push({ name: 'Home' })
    },
    handleClickTab(tabNumber){
      this.currentTab = tabNumber
    },
    handleRefreshCustomer() {
      this.$refs.measurementTab.refreshCustomerMeasures()
      this.$refs.orderTab.refreshCustomerOrders()
      this.$refs.addressTab.refreshCustomerAddresses()
    },
    totalPrice(order) {
      let productsPrice = 0

      order.products.forEach((product) => {
        productsPrice += this.computeProductPrice(product)
      })

      const reductionsPrice = this.reductionsPrice(order)
      const deliveryPrice = this.deliveryPrice(
        order,
        reductionsPrice,
        productsPrice
      )
      return productsPrice + reductionsPrice + deliveryPrice
    },
    computeProductPrice(product) {
      let price = 0
      Object.keys(product.options).forEach((optionId) => {
        const option = product.options[optionId]
        Object.keys(option).forEach((parameterId) => {
          const parameter = option[parameterId]
          if (parameter.price) price += parseFloat(parameter.price)
        })
      })
      return price
    },
    reductionsPrice(order) {
      let reductions = 0
      if (order.reductions.pack3 === true) reductions += 17
      if (order.reductions.pack5 === true) reductions += 45
      if (order.reductions.parrainage === true) reductions += 20
      reductions += parseInt(order.discount ? order.discount : 0, 10)
      return reductions
    },
    deliveryPrice(order, reductions, productsPrice) {
      let delivery = 8

      /* Delivered to shop. */
      if (order.options.shop_delivery) {
        delivery = 0
      } else if (order.options.quick_delivery) {
        /* Quick delivery. */
        delivery = 25
      } else if (productsPrice - reductions < 150) {
        /* Price above 150 €, free delivery. */
        delivery = 0
      }

      if (order.options.free_delivery === true) {
        delivery = 0
      }

      /* Quick making: 20€ for the first shirt + 10€ per others. */
      if (order.quick_making === true) {
        delivery += 20 + (order.products.length - 1) * 10
      }

      return delivery
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomerView.vue?ce479b32